import { type Localisation } from "./en";

export const german: Localisation = {
  dateFormats: {
    currentDateFormat: "eee, do LLLL",
    currentTimeFormat: "HH:mm",
    dateDayMonth: "eeee do LLLL",
    hoursMinutes: "HH:mm",
    dateDay: "eeee do",
  },
  StatusProvider: {
    "Screen is active but no token is present":
      "Der Bildschirm ist aktiv, aber es ist kein Token vorhanden",
    "Network error": "Netzwerkfehler",
    "Checking display status": "Anzeigestatus prüfen",
    "Failed to get display status":
      "Anzeigestatus konnte nicht abgerufen werden",
    "Device ID: {{deviceId}}": "Device ID: {{deviceId}}",
    "If this issue persists, please contact your Teamworks administrator.":
      "Wenn dieses Problem weiterhin besteht, wenden Sie sich bitte an Ihren Teamworks-Administrator.",
    "This is usually due to a network error while setting up your device. Please reset your device using the button below and try again.":
      "Dies liegt normalerweise an einem Netzwerkfehler beim Einrichten Ihres Geräts. Bitte setzen Sie Ihr Gerät mit der Schaltfläche unten zurück und versuchen Sie es erneut.",
    "Setup failed to complete":
      "Die Einrichtung konnte nicht abgeschlossen werden",
    "Please reset your device using the button below and try again.":
      "Die Einrichtung konnte nicht abgeschlossen werden. Bitte setzen Sie Ihr Gerät mit der Schaltfläche unten zurück und versuchen Sie es erneut.",
  },
  ConfigProvider: {
    "Loading configuration": "Konfiguration wird geladen",
  },
  AppProvider: {
    Loading: "Laden",
    "No configuration selected": "Keine Konfiguration ausgewählt",
    "We could not find a configuration for the given code. Please contact your Teamworks administrator.":
      "Wir konnten keine Konfiguration für den angegebenen Code finden. Bitte wenden Sie sich an Ihren Teamworks-Administrator.",
    "This device has been registered, but no configuration has been set yet. Dont worry, you can easily update this device in the digital displays management app.":
      "Dieses Gerät wurde registriert, aber es wurde noch keine Konfiguration vorgenommen. Keine Sorge, Sie können dieses Gerät ganz einfach in der App zur Verwaltung digitaler Displays aktualisieren.",
    "Network error: failed to load playlist":
      "Netzwerkfehler: Wiedergabeliste konnte nicht geladen werden",
    "Device ID: {{deviceId}}": "Geräte-ID: {{deviceId}}",
    "Resetting, please wait...": "Wird zurückgesetzt, bitte warten Sie...",
  },
  UpdatesProvider: {
    "Checking for update": "Suche nach Updates",
    "Downloading update": "Update wird heruntergeladen",
  },
  InteractionScreen: {
    "Loading...": "Laden...",
    "Press any key to begin":
      "Drücken Sie eine beliebige Taste, um zu beginnen",
    "No configurations assigned": "Keine Konfigurationen zugewiesen",
    "You can assign a configuration or a playlist to run on this device in the Digital Displays management app.":
      "Sie können in der Digital Displays-Verwaltungs-App eine Konfiguration oder eine Wiedergabeliste zuweisen, die auf diesem Gerät ausgeführt werden soll.",
  },
  SetupScreen: {
    "Scan the QR code on your camera app":
      "Scannen Sie den QR-Code in Ihrer Kamera-App",
  },
  TemplateScreen: {
    "Events page {{count}} of {{total}}":
      "Veranstaltungen Seite {{count}} von {{total}}",
    Today: "Heute",
    "All day": "Den ganzen Tag",
    Tomorrow: "Morgen",
  },
  ErrorScreen: {
    "Something went wrong": "Etwas ist schief gelaufen",
    "Sorry for the inconvience, our engineers have been notified and will be working on a fix":
      "Wir entschuldigen uns für die Unannehmlichkeiten. Unsere Techniker wurden benachrichtigt und werden an einer Lösung arbeiten",
    "If this issue persists, please contact your account manager":
      "Wenn das Problem weiterhin besteht, wenden Sie sich bitte an Ihren Account Manager",
    "Reset device": "Gerät zurücksetzen",
    "Your IP address may need to be permitted: {{ip}}":
      "Ihre IP-Adresse muss möglicherweise zugelassen werden: {{ip}}",
    "The app will attempt to automatically reset in {{seconds}} seconds":
      "Die App wird in {{seconds}} Sekunden automatisch zurückgesetzt",
  },
  NextMatch: {
    days: "Tage",
    hours: "Std",
    minutes: "Minuten",
    seconds: "Sekunden",
  },
  MediaContentCarosel: {
    "Media not found": "Medien nicht gefunden",
  },
  PlaylistProvider: {
    "Loading...": "Wird geladen...",
    "Loading playlist": "Wiedergabeliste wird geladen",
  },
  ScreenFooter: {
    Hardcoded: "Hartcodiert",
  },
  NotFoundLayout: {
    "Configuration not found": "Konfiguration nicht gefunden",
  },
  StrengthWorkoutBoard: {
    "No Workout Selected": "Kein Workout ausgewählt",
    "Select a workout from the Digital Display tab in S&C to display it here":
      "Wähle im Digital Display-Tab in S&C ein Workout aus, um es hier anzuzeigen",
  },
  WeatherWidget: {
    "Weather unavailable": "Wetter nicht verfügbar",
  },
  NutritionMenu: {
    "Failed to fetch menu": "Menü konnte nicht abgerufen werden",
  },
  NutritionDiningStation: {
    "Failed to fetch dining station":
      "Essensstation konnte nicht abgerufen werden",
    "Add ons will affect nutrition information":
      "Ergänzungen beeinflussen die Nährwertinformationen",
  },
  Weather: {
    Today: "Today",
    "No weather data to show, please contact your Teamworks administrator.":
      "Keine Wetterdaten verfügbar, bitte kontaktieren Sie Ihren Teamworks-Administrator.",
    Clear: "Klar",
    Clouds: "Bewölkt",
    Rain: "Regen",
    Drizzle: "Nieselregen",
    Thunderstorm: "Gewitter",
    Snow: "Schnee",
    Mist: "Dunst",
    Smoke: "Rauch",
    Haze: "Dunst",
    Dust: "Staub",
    Fog: "Nebel",
    Sand: "Sand",
    Ash: "Vulkanasche",
    Squall: "Bö",
    Tornado: "Tornado",
  },
};
